<template>
  <div class="breadcrumbs">
    <div class="col-sm-4">
      <div class="page-header float-left">
        <div class="page-title">
          <h1>{{$t(breadcrumbstitle)}}</h1>
        </div>
      </div>
    </div>
    <div class="col-sm-8">
      <div class="page-header float-right">
        <div class="page-title">
          <ol class="breadcrumb text-right">

            <li v-for="(row, i) in breadcrumbsData">
              <template v-if="row.url">
                <router-link :to="{ path: '/'+row.url}" class="">{{$t(row.title)}}</router-link>
              </template>
              <template v-if="!row.url">
                <a class="">{{$t(row.title)}}</a>
              </template>
            </li>

          </ol>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Breadcrumbs',
    data(){

      return {}
    },
    props: {
      breadcrumbstitle: String, // primary secondary success danger warning info light dark
      breadcrumbsData: Array,
    },
    methods: {
      something(e){
        return e;
      },
    }

  };
</script>

<style>

</style>


